module.exports = __webpack_public_path__ + "79107dad9a017ac61e43bf035fb75904.jpg";